<template>
</template>

<script>
import AuthRepository from '../services/AuthRepository'
import Auth from '@/mixins/auth'

export default {
  name:"SSO",
    mounted() {
      const getQueryParams = (url) => {
        let queryParams = {};
      //create an anchor tag to use the property called search
        let anchor = document.createElement('a');
      //assigning url to href of anchor tag
        anchor.href = url;
      //search property returns the query string of url
        let queryStrings = anchor.search.substring(1);
        let params = queryStrings.split('&');

        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split('=');
            queryParams[pair[0]] = decodeURIComponent(pair[1]);
        }
        return queryParams;
      };
      const body = {
        sso_token: getQueryParams(window.location.href).sso_token
      }
      const view = getQueryParams(window.location.href).view 
      console.log("QUERYPARAMETERS", getQueryParams(window.location.href))
      // const body = {
      //   sso_token: "9A9D6F3C2D15DAA9F2A249EC239DE14305A59D273E99E5BCDD8C885A5D7E6E27E5D7B11736FF42DB3824522C6B"
      // }
      AuthRepository.sooLogin(body).then( result => {
        Auth.setSession(result.data)
        const session = Auth.getSession()
        if(session) { 
          if(view == "1"){
            this.$router.push('/dashboard')
          }else if(view == "2"){
            this.$router.push('/quotation/new')
          }
          
        }
      })
      .catch( error => {
        console.log("ERRORPRUEBA",error);
        console.log("DATA",error.response);
        console.log("STATUS",error.response.status);
        console.log("HEADERS",error.response.headers);
        if (error.response.status === 502) {
          this.$router.push({ name: 'SSOError', params: { serverError: true }})
        }
        if (error.response.status === 404) {
          this.$router.push({ name: 'SSOError', params: { serverError: false }})
        }
      })
    }
}
</script>